import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { deletePhotoAPI, getUserPhotoAPI } from '../api/photo';
import { getManagerMode, getManagerRobotId, getUserPId } from '../common/util';

const MODULE_PHOTO = 'photoBot';
const initialState = {
  loading: false,
  pending: false,
  lists: [],
  listLength: 0,
  total: 0,
  error: null,
  delete: { result: false, photo: null },
};

export const getData = createAsyncThunk(
  `${MODULE_PHOTO}/getData`,
  async (params, { rejectWithValue, getState }) => {
    try {
      const conditions = { ...params, userId: getUserPId() };
      if (getManagerMode()) {
        conditions.robotId = getManagerRobotId();
      }
      const { result, total, list: data } = await getUserPhotoAPI(conditions);
      if (result) {
        const { skip, limit } = conditions;
        const { lists: prevLists, listLength: prevListLength } =
          getState()[MODULE_PHOTO];
        const listLength = total > skip + limit ? skip + limit : total;

        if (skip && skip === prevListLength) {
          const prevLastItem = prevLists[prevLists.length - 1];
          const [[d, ls]] = Object.entries(prevLastItem);
          const [[date, list]] = Object.entries(data[0]);
          if (d === date) {
            data.splice(0, 1);
            const lists = prevLists.map((item, idx) => {
              if (prevLists.length - 1 === idx) {
                return { [d]: ls.concat(list) };
              }
              return item;
            });
            return {
              lists: lists.concat(data),
              total,
              listLength,
            };
          }
          return {
            lists: prevLists.concat(data),
            total,
            listLength,
          };
        }
        return { lists: data, total, listLength };
      }
      return rejectWithValue('사진 목록 로드 중 에러가 발생하였습니다.');
    } catch (error) {
      return rejectWithValue('사진 목록 로드 중 에러가 발생하였습니다.');
    }
  },
);

export const deleteItem = createAsyncThunk(
  `${MODULE_PHOTO}/delete`,
  async (photo, { rejectWithValue }) => {
    try {
      const { result, error } = await deletePhotoAPI({
        userPId: getUserPId(),
        photo,
      });
      if (result) return result;
      if (error) return rejectWithValue(error.desc);
      return rejectWithValue('사진 삭제 중 오류가 발생했습니다.');
    } catch (error) {
      return rejectWithValue('사진 삭제 중 오류가 발생했습니다.');
    }
  },
);

const photoSlice = createSlice({
  name: MODULE_PHOTO,
  initialState,
  reducers: {
    init: () => ({ ...initialState }),
  },
  extraReducers: {
    [getData.pending.type]: (state) => ({ ...state, loading: true }),
    [getData.fulfilled.type]: (state, action) => ({
      ...state,
      loading: false,
      ...action.payload,
    }),
    [getData.rejected.type]: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload,
    }),
    [deleteItem.pending.type]: (state) => ({
      ...state,
      pending: true,
      delete: { result: null, photo: null },
    }),
    [deleteItem.fulfilled.type]: (state) => ({
      ...state,
      pending: false,
      delete: { result: true, photo: '사진을 삭제했습니다.' },
    }),
    [deleteItem.rejected.type]: (state, action) => ({
      ...state,
      pending: false,
      delete: { result: false, photo: action.payload },
    }),
  },
});

const { reducer: PhotoReducer, actions } = photoSlice;
export const { init } = actions;

export default PhotoReducer;
